import { render, staticRenderFns } from "./TransactionConfig.vue?vue&type=template&id=2f99cce0&scoped=true"
import script from "./TransactionConfig.vue?vue&type=script&lang=js"
export * from "./TransactionConfig.vue?vue&type=script&lang=js"
import style0 from "./TransactionConfig.vue?vue&type=style&index=0&id=2f99cce0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f99cce0",
  null
  
)

export default component.exports